<template>
  <div class="scan">
    <qrcode-stream :track="paintBoundingBox" @detect="onDetect" @error="onError"></qrcode-stream>
    <div style="padding-top: 5px;">{{ result }}</div>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  components: {
    'qrcode-stream': QrcodeStream
  },
  data() {
    return {
      result: '',
      error: '',
      objt: {},
    }
  },
  created() {
    const path = require("path");
    console.log('fcl', path.resolve(__dirname, 'key.pem'));
    this.objt = navigator.mediaDevices
    this.clickCode();
  },
  mounted() {
    window.onerror = (message, source, lineno, colno, error) => {
      this.errorMessage = `${message} at ${source}:${lineno}:${colno}`;
      console.log('err', this.errorMessage)
    };
  },
  methods: {
    paintBoundingBox(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const {
          boundingBox: { x, y, width, height }
        } = detectedCode

        ctx.lineWidth = 2
        ctx.strokeStyle = '#007bff'
        ctx.strokeRect(x, y, width, height)
      }
    },
    onDetect(detectedCodes) {
      detectedCodes.then((res) => {
        this.result = res.content;
      });
      // this.detectedCodes = detectedCodes;
      // this.result = JSON.stringify(
      //   detectedCodes.map(code => code.rawValue)
      // )
    },
    onError(err) {

      this.error = `[${err.name}]: `

      if (err.name === 'NotAllowedError') {
        this.error += 'you need to grant camera access permission'
      } else if (err.name === 'NotFoundError') {
        this.error += 'no camera on this device'
      } else if (err.name === 'NotSupportedError') {
        this.error += 'secure context required (HTTPS, localhost)'
      } else if (err.name === 'NotReadableError') {
        this.error += 'is the camera already in use?'
      } else if (err.name === 'OverconstrainedError') {
        this.error += 'installed cameras are not suitable'
      } else if (err.name === 'StreamApiNotSupportedError') {
        this.error += 'Stream API is not supported in this browser'
      } else if (err.name === 'InsecureContextError') {
        this.error += 'Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.'
      } else {
        this.error += err.message
      }


    },
    clickCode() {
      this.scancode = true;
    },
  }
}
</script>
